import { useState } from 'react';

import { API_BASE_URL } from '../config/config';
import {
  ApiResponse_iEnumerable_1,
  ApiResponse_searchResponseDTO_1,
  SearchRequestDTO_auditLogSearchRequestDTO,
  AuditLogClient,
} from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

interface UseAuditLogApi {
  getTableNames: () => Promise<ApiResponse_iEnumerable_1>;
  search: (
    filters: SearchRequestDTO_auditLogSearchRequestDTO,
  ) => Promise<ApiResponse_searchResponseDTO_1>;
  isLoading: boolean;
  error: string | null;
}

export const useAuditLogApi = (): UseAuditLogApi => {
  const apiClient = new AuditLogClient(API_BASE_URL, axiosInstance);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getTableNames = async (): Promise<ApiResponse_iEnumerable_1> => {
    setIsLoading(true);
    try {
      return await apiClient.getDistinctTableNames();
    } catch (err: unknown) {
      handleHookError(err, 'Error getting table names', setError);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const search = async (
    filters: SearchRequestDTO_auditLogSearchRequestDTO,
  ): Promise<ApiResponse_searchResponseDTO_1> => {
    setIsLoading(true);
    try {
      return await apiClient.searchAuditLogs(filters);
    } catch (err: unknown) {
      handleHookError(err, 'Error searching audit logs', setError);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { getTableNames, search, isLoading, error };
};
